import * as api from "app/api/planning"
import { SagaIterator } from "redux-saga"
import { call, put, takeLatest } from "redux-saga/effects"
import { handleError } from "app/redux/errorHandler/errorHandler.saga"
import * as actions from "./practices.actions"

export function* getPracticesFlow(): SagaIterator {
  try {
    const response = yield call(api.getPractices)
    yield put(actions.getPracticesSuccess(response && response.data))
  } catch (e) {
    yield put(actions.getPracticesFail(e))
    yield call(handleError, { error: e })
  }
}

export default function* practicesSaga(): SagaIterator {
  yield takeLatest(actions.Types.GET, getPracticesFlow)
}
